// @owners { team: patient-fulfillment }
import { Body, Card, InlineAlert, LgPadding } from '@alto/design-system';
import React from 'react';
import { CONTACT_US_ORIGIN } from '~shared/constants';
import { usePrescriptionsInCart } from '~shared/features/cart/hooks/usePrescriptionsInCart';
import { getOrderDate } from '~shared/features/checkout/selectors/getOrder';
import { getProgynyWizardCycle } from '~shared/selectors/checkout/progyny';
import { useSelectorShared } from '~shared/store';
import { ContactUs } from '../../../alto-assistant';
import { CHECKOUT_STRINGS } from '../../../progyny-wizard/constants';
import { useCheckoutAddressInfoKeys } from '../../hooks/useCheckoutAddressInfoKeys';
import { WindowSelector } from '../delivery-date-card/WindowSelector';

export const SelectTimeCard = () => {
  const { hasInjectables } = usePrescriptionsInCart();
  const inProgynyWizard = useSelectorShared(getProgynyWizardCycle);
  const fetchDeliveryWindowsLoading = useSelectorShared((state) => state.ui.loading.fetchDeliveryWindowsLoading);
  const date = useSelectorShared(getOrderDate);
  const { deliveryWindowRequired } = useCheckoutAddressInfoKeys();
  const showDeliveryWindow = !!date && deliveryWindowRequired;
  const showInjectionWarning = !fetchDeliveryWindowsLoading && (hasInjectables || !!inProgynyWizard);

  if (!showDeliveryWindow) {
    return null;
  }

  return (
    <Card
      title="Select time"
      overflow="hidden"
    >
      <WindowSelector />
      {showInjectionWarning ? (
        <LgPadding>
          <InlineAlert type="warning">
            <Body>
              {CHECKOUT_STRINGS.MEDICATION_START_DATE} Please{' '}
              <ContactUs
                type="link"
                method="message"
                origin={CONTACT_US_ORIGIN.CheckoutDateSelector}
              />
              , or{' '}
              <ContactUs
                origin={CONTACT_US_ORIGIN.CheckoutDateSelector}
                type="link"
                method="phone"
              />{' '}
              if you need a medication more urgently.
            </Body>
          </InlineAlert>
        </LgPadding>
      ) : null}
    </Card>
  );
};
